module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_green.a801b18d.svg";